import { FeatureFlags } from '../constants/featureFlags';
import type { InventoryMode } from '../models/configuration';

const MULTI_MODE: InventoryMode = 'multi';

/** True when the feature flag is on and the org uses per-warehouse stock balances. */
export function isMultiWarehouseMode(
  mode: InventoryMode | null | undefined
): boolean {
  return FeatureFlags.multiWarehouseEnabled && mode === MULTI_MODE;
}

/** Normalize stored value; missing → single (backward compatible). */
export function resolveInventoryMode(
  mode: string | null | undefined
): InventoryMode {
  return mode === MULTI_MODE ? MULTI_MODE : 'single';
}
